import { FeatheredImage } from "../../FeatheredImage";

const A = "/brand";
const IMG = `${A}/blueprint4joy-visionbook-joyspotsketch.jpg`;
const ALT = "A handwritten JOYspot sketch showing overlapping circles for Dreams + Goals, Core Values, Faith and Family.";

export function WhyItWorks() {
  return (
    <section data-testid="vbw-why-it-works-section" className="relative overflow-hidden bg-[#FAFAF8]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-[36px] md:py-[47px] reveal">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_60%] gap-10 lg:gap-14 items-start">
          {/* Text — left on desktop, unchanged */}
          <div className="order-2 lg:order-1">
            <p className="text-xs tracking-[0.24em] uppercase text-[#159E9A] mb-5">
              Why It Works
            </p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-[50px] leading-[1.1] tracking-tight text-[#1C1917] mb-7 max-w-lg">
              Sometimes our hearts recognize truth before our minds do.
            </h2>
            <div className="space-y-4 text-[20px] md:text-[22px] leading-relaxed text-[#57534E] max-w-lg">
              <p>Before we can explain what matters&hellip;</p>
              <p>we often feel it.</p>
              <p>An image makes us pause.</p>
              <p>A single word refuses to let us go.</p>
              <p>A photograph reminds us of someone we love.</p>
              <p>A place we&rsquo;ve never visited suddenly feels familiar.</p>
              <p>Little by little, patterns begin to emerge.</p>
              <p>Not because someone is telling us what our future should look like.</p>
              <p>
                Because we&rsquo;re finally paying attention to what has quietly
                been there all along.
              </p>
              <p>A Vision Book isn&rsquo;t built around perfect goals.</p>
              <p>It&rsquo;s built around honest curiosity.</p>
              <p>The result isn&rsquo;t a book filled with beautiful pictures.</p>
              <p className="text-[#1C1917]">It&rsquo;s a clearer understanding of yourself.</p>
            </div>

            <div className="mt-9 space-y-1">
              <p className="font-display text-xl md:text-2xl text-[#57534E] italic leading-snug max-w-lg">
                A Vision Book doesn&rsquo;t ask you to become someone else.
              </p>
              <p className="font-display text-xl md:text-2xl text-[#159E9A] italic leading-snug max-w-lg">
                It helps you remember what your heart has been quietly pulling
                you toward all along.
              </p>
            </div>
          </div>

          {/* Photograph — right on desktop, increased to ~150% of its prior
              displayed size (~40% -> 60% of content width via the 1fr/60%
              column split), nudged down so its top edge lands near "An
              image makes us pause." Native 1500:2000 aspect ratio, zero
              hard crop. */}
          <div className="order-1 lg:order-2 lg:mt-[250px]">
            <div className="relative w-full max-w-sm mx-auto lg:max-w-none" style={{ aspectRatio: "1500 / 2000" }}>
              <FeatheredImage
                src={IMG}
                alt={ALT}
                testId="vbw-why-it-works-image"
                objectPosition="center"
                featherLeft={10}
                featherRight={10}
                featherTop={10}
                featherBottom={10}
                className="absolute inset-0"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
